import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurStoryAndMission from "./sections/OurStoryAndMission";
import MeetOurExpertTeam from "./sections/MeetOurExpertTeam";
import WhyIronPeakExists from "./sections/WhyIronPeakExists";
import HowWePracticeMedicine from "./sections/HowWePracticeMedicine";
import WhatMakesIronPeakDifferent from "./sections/WhatMakesIronPeakDifferent";
import WhoWeWorkWith from "./sections/WhoWeWorkWith";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurStoryAndMission />
      <WhyIronPeakExists />
      <HowWePracticeMedicine />
      <WhatMakesIronPeakDifferent />
      <WhoWeWorkWith />
      <MeetOurExpertTeam />
      <Footer />
    </div>;
}